import { formatMoney } from 'accounting'

import { faLock, faLockOpen } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useDefaultQuoteItem from '@hooks/useDefaultQuoteItem'

import type { DefaultQuoteItemModel } from '@models/types'

interface DefaultQuoteItemProps {
  defaultQuoteItem: DefaultQuoteItemModel,
}

const DefaultQuoteItemListItem = (props: DefaultQuoteItemProps) => {
  const {
    defaultQuoteItem,
    defaultQuoteItem: {
      allow_toggle,
      display_title,
      item_type,
      title,
      value,
      value_type,
    },
  } = props

  const isPercentage = value_type === 'percentage'
  const itemValue = isPercentage ? `${value}%` : formatMoney(value)

  const {
    callbacks: { createOrEditDefaultQuoteItem },
  } = useDefaultQuoteItem(defaultQuoteItem)

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditDefaultQuoteItem()}
      secondaryText={(
        <>
          <FontAwesomeIcon icon={allow_toggle ? faLockOpen : faLock} style={{ marginRight: 4 }} />
          {allow_toggle ? 'Optional' : 'Required'}
        </>
      )}
      title={item_type === 'orderable' ? display_title : title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>{itemValue}</DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default DefaultQuoteItemListItem
